/* stylelint-disable */
.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.range-presentation-tab {
  display: flex;
  margin: 0 auto;
  padding: 20px 7px 48px;
}

@media screen and (min-width: 980px) {
  .range-presentation-tab {
    padding: 0 0 98px;
  }
}

.range-presentation-tab ul {
  padding: 0 0 12px;
}

.range-presentation-tab ul li {
  list-style: disc inside;
  text-indent: 0;
  margin-bottom: 15px;
  color: #626469;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.21875rem;
}

.range-presentation-tab p {
  color: #626469;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.21875rem;
}

.range-presentation-tab a {
  display: inline-block;
  border-radius: var(--qds-focus-border-radius);
  box-sizing: border-box;
  text-decoration: underline;
  color: var(--qds-theme-link-standard-default);
}

.range-presentation-tab a:visited {
  color: var(--qds-theme-link-standard-visited);
}

.range-presentation-tab a:hover {
  color: var(--qds-theme-link-standard-hover);
}

.range-presentation-tab a:active {
  color: var(--qds-theme-link-standard-pressed);
}

.range-presentation-tab a:visited:hover {
  color: var(--qds-theme-link-standard-visited-hover);
}

.range-presentation-tab a:visited:active {
  color: var(--qds-theme-link-standard-visited-pressed);
}

.range-presentation-tab a[rel~=external] > .qds-external {
  display: inline-block;
}

.range-presentation-tab a:focus-visible {
  outline: var(--qds-theme-focus-border) solid var(--qds-focus-border-width);
}

.range-presentation-tab a[aria-disabled=true] {
  opacity: var(--qds-theme-disabled);
  pointer-events: none;
}

.range-presentation-tab strong {
  line-height: 2.125rem;
}

.range-presentation-tab table {
  width: 100%;
}

.range-presentation-tab__additional-links {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: baseline;
}

@media screen and (min-width: 720px) and (max-width: 980px) {
  .range-presentation-tab__additional-links {
    grid-template-columns: 1fr 1fr;
  }
}

@media screen and (max-width: 719px) {
  .range-presentation-tab__additional-links {
    grid-template-columns: 1fr;
  }
}

.range-presentation-tab__additional-link {
  padding: 20px 15px;
}

.range-presentation-tab__more-features {
  margin-top: 20px;
}

.list-images {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

@media screen and (min-width: 980px) {
  .list-images {
    justify-content: start;
  }
}

.list-images__image {
  width: 100%;
}

.list-images li.list-images__image-wrapper {
  max-width: calc(50% - 20px);
  list-style: none;
  display: list-item;
  flex-direction: column;
  margin: 0;
  padding: 0;
  border-bottom: 40px solid transparent;
}

@media screen and (min-width: 980px) {
  .list-images li.list-images__image-wrapper {
    width: 196px;
    justify-content: start;
    border-bottom: 40px solid transparent;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
  }
}

.range-presentation-tab__article + .range-presentation-tab__article {
  border-top: solid 1px #e6e6e6;
  margin-top: 27px;
}

.range-presentation-tab__article__header,
.range-presentation-tab__article h3 {
  font-size: 2.5rem;
  color: #3dcd58;
  line-height: 1.5em;
  font-weight: 400;
  text-align: center;
}

@media screen and (max-width: 979px) {
  .range-presentation-tab__article__header,
.range-presentation-tab__article h3 {
    margin: 0 0 20px;
  }
}

@media screen and (min-width: 980px) {
  .range-presentation-tab__article__header,
.range-presentation-tab__article h3 {
    text-align: left;
    margin: 0 0 15px;
  }
}

.range-presentation-tab__article iframe {
  max-width: 100%;
}

.range-presentation-tab__sdl-content {
  box-sizing: border-box;
}

.range-presentation-tab__sdl-content *,
.range-presentation-tab__sdl-content *::before,
.range-presentation-tab__sdl-content *::after {
  box-sizing: inherit;
}

@media screen and (max-width: 979px) {
  .range-presentation-tab__sdl-content {
    margin-top: 20px;
  }
}

@media screen and (min-width: 980px) {
  .range-presentation-tab__sdl-content {
    margin-top: 40px;
  }
}

.range-presentation-tab__sdl-content a:hover {
  text-decoration: underline;
}